import cn from 'classnames';
import { LoaderImage, LoaderPage } from '@loader-current';

// Фасад над лоадером темы (@loader-current → Loader/Orbits | Loader/Dots, выбор —
// LOADER в vite.config). Варианты различаются разметкой, а не цветом, поэтому за
// алиасом компонент. Раньше выбор шёл тернаром по isBlueTheme, и стили обоих
// вариантов лежали в каждом бандле.
export const Loader = ({ className }: { className?: string }) => (
  <div className={cn('w-full', className)}>
    <LoaderImage />
  </div>
);

// Загрузчик на весь экран — пока нет каркаса (холодный старт в RequireAuth). У
// темы может быть своя разметка (telecom — знак в кольце на красной волне),
// у остальных это тот же лоадер по центру.
export const PageLoader = () => <LoaderPage />;
